module.exports = __webpack_public_path__ + "static/media/img_homepage_menu_01-About_default.34e2c3a5.png";